module.exports = __webpack_public_path__ + "img/125.5a51bfce.svg";